export default {"src":"/_next/static/media/Fomoin.e566f219.svg","height":178,"width":856,"blurWidth":0,"blurHeight":0};